module.exports = __webpack_public_path__ + "static/timeline-vertical-64ef4f4673ec8ce41deef033b765130b.svg";